<div role="group" class="nimbus-range-input-container" (focusin)="onFocusIn()" (focusout)="onFocusOut($event)">
  <input
    #numberInput
    type="number"
    class="range-input"
    [formControl]="control"
    [min]="minValue"
    [max]="maxValue"
    [step]="step"
    (input)="handleInput()"
    (blur)="onBlur()"
  />
  @if (unit) {
    <span class="range-input-unit">{{ unit }}</span>
  }
</div>
